import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { BookmarkRounded as BookmarkIcon } from '@material-ui/icons'
import Typography from './typography'
import {
  userConfigError,
  addFavoriteTransfer,
  addedFavoriteTransfer,
  deleteFavoriteTransfer,
  deletedFavoriteTransfer,
  resetUserConfig,
} from '../../../redux/userConfiguration/actions'
import useStyles from './itemListTransferStyle'
import SelectFieldMini from '../inputs/selectFieldMini'
import api from '../../../services/api'
import HighlightSearch from '../display/highlightSearch'

const ItemListTransfer = (props) => {
  const dispatch = useDispatch()
  const chatKeyword = useSelector((state) => state.keyword)
  const classes = useStyles()
  const theme = useTheme()
  const [selectedSkill, setSelectedSkill] = useState()
  const [loading, setLoading] = useState(false)

  const addFavorite = async () => {
    const itemId = props?.itemId

    dispatch(addFavoriteTransfer(itemId))
    try {
      const response = await api.post(`/userconfs`, {
        [`${props?.type}_id`]: itemId,
      })
      if (response.status === 200) {
        const configId = response?.data?.id?.id
        dispatch(addedFavoriteTransfer(configId, props?.type, itemId))
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      console.error(error)
      dispatch(
        userConfigError({ action: 'add_favorite_transfer', message: message })
      )
    }
    dispatch(resetUserConfig('add_favorite_transfer'))
  }

  const deleteFavorite = async () => {
    const configId = props?.configId
    const itemId = props?.itemId

    dispatch(deleteFavoriteTransfer(configId, itemId))
    try {
      const response = await api.delete(
        `/userconfs${configId ? '?id=' + configId : ''}`,
        {
          data: { content_id: itemId },
        }
      )
      if (response.status === 200) {
        dispatch(deletedFavoriteTransfer(configId, props?.type, itemId))
      } else {
        throw response.data
      }
    } catch (error) {
      let message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      dispatch(
        userConfigError({
          action: 'delete_favorite_transfer',
          message: message,
        })
      )
    }
    dispatch(resetUserConfig('delete_favorite_transfer'))
  }

  const handleBookmark = async () => {
    if (!loading) {
      const action = !props?.bookmarked ? addFavorite : deleteFavorite
      setLoading(true)
      await action()
      setLoading(false)
    }
  }

  return (
    <>
      <div
        className={`${classes.root} ${props?.active ? classes.active : ''}`}
        onClick={() => props.onClick(selectedSkill)}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {/* {props?.type !== 'skill' && (
            <>
              <div
                className={
                  props.quantity > 0 ? classes.statusOn : classes.statusOff
                }
              />
            </>
          )} */}
          <HighlightSearch
            text={props.text}
            keyword={chatKeyword}
            anchor={props?.type}
            copy={false}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="body1"
            style={{
              color: props.online
                ? theme.palette.primary.main
                : theme.palette.details,
            }}
          >
            {props?.type === 'skill' ? (
              `( ${props.quantity} online )`
            ) : (
              <SelectFieldMini
                el={props.el}
                data={props.data}
                setSelectedSkill={(skillId) => {
                  props.setSelectedSkill(skillId)
                  setSelectedSkill(skillId)
                }}
              />
            )}
          </Typography>
          {loading ? (
            <CircularProgress
              size={20}
              color="primary"
              style={{ marginLeft: 5 }}
            />
          ) : (
            <BookmarkIcon
              className={`${classes.bookmark} ${
                props?.bookmarked ? classes.bookmarked : ''
              }`}
              onClick={(e) => {
                e.stopPropagation()
                handleBookmark()
              }}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default ItemListTransfer
